// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d72b5e98","488":"a13cac03","977":"bdf82d13"}[chunkId] + ".chunk.js";
};